export default __webpack_public_path__ + "static/gearsOfWarOmen-white-57862e4767b60a3fbf26526827cff5e3.svg";